import { render, staticRenderFns } from "./welder.vue?vue&type=template&id=59e1f9e6&scoped=true&"
import script from "./welder.vue?vue&type=script&lang=js&"
export * from "./welder.vue?vue&type=script&lang=js&"
import style0 from "./welder.vue?vue&type=style&index=0&id=59e1f9e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e1f9e6",
  null
  
)

export default component.exports